import { render, staticRenderFns } from "./SummaryCol.vue?vue&type=template&id=845f965c&"
import script from "./SummaryCol.vue?vue&type=script&lang=js&"
export * from "./SummaryCol.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCol.vue?vue&type=style&index=0&id=845f965c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports